import classNames from 'classnames';
import React from 'react';
import {
	Link,
} from 'react-router5';

import useUrlState from '~/hooks/useUrlState';

import useNavigationLinkClick from '~/hooks/useNavigationLinkClick';

import {
	type RenderProp,
	renderProp,
} from '~/utilities/renderProp';



type ChildProps = {
	isActive: boolean,
	isDimmed: boolean,
};

type Props = {
	accountId?: number | null,
	children: RenderProp<ChildProps>,
	className?: string,
	onClick?: () => void,
};

/**
 * Link to Your Profile (Manage My Profile) - same pattern as AccountLink.
 * Uses account.yourProfile route: /account/your_profile?accountId=X
 */
const YourProfileLink: React.FC<Props> = (props) => {
	const {
		accountId,
		children,
		className,
		onClick,
	} = props;

	const urlState = useUrlState();

	const isActive = urlState.name === 'account.yourProfile' || urlState.name.startsWith('account.yourProfile.');

	const handleClick = useNavigationLinkClick(onClick);

	const finalClassName = classNames({
		'active': isActive,
	}, className);

	return (
		<Link
			className={finalClassName}
			onClick={handleClick}
			routeName="account.yourProfile"
			routeParams={{
				accountId: accountId ?? undefined,
			}}
		>
			{renderProp(
				children,
				{
					isActive,
					isDimmed: false,
				},
			)}
		</Link>
	);
};



export default YourProfileLink;
